import { useQuery } from "@tanstack/react-query";
import { fetchSubstanceMarketProducts } from "@/services/substance_api";
import type { SubstanceKind } from "@/utils/types/substance";

export function useSubstanceMarketProducts(
  kind: SubstanceKind | null,
  id: number | null,
) {
  return useQuery({
    queryKey: ["substanceMarketProducts", kind, id] as const,
    queryFn: ({ signal }) => fetchSubstanceMarketProducts(kind!, id!, signal),
    enabled: kind !== null && id !== null,
    staleTime: 60_000,
  });
}
